module.exports = __webpack_public_path__ + "img/4d.ed0f1a79.png";